/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_LocalityInputs */

const cs_requirements_locality = /** @type {(inputs: Requirements_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalita (katalog)`)
};

const en_requirements_locality = /** @type {(inputs: Requirements_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locality (catalog)`)
};

/**
* | output |
* | --- |
* | "Locality (catalog)" |
*
* @param {Requirements_LocalityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_locality = /** @type {((inputs?: Requirements_LocalityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_LocalityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_locality(inputs)
	return cs_requirements_locality(inputs)
});